import type {
	ReduxQuote,
	ReduxQuoteInfo,
	ReduxRecapInfo,
} from 'src/types/apiType'
import type { QuoteTotals } from 'src/types/quoteTotalsTypes'
import { quoteTotalsSummary } from 'src/utils/quote/quoteTotalsSummary/frenchApfpAndPostProdQuoteTotalsSummary'
import { photoGridTotalsSummary } from 'src/utils/quote/quoteTotalsSummary/photoGridTotalsSummary'
import { soundProdTotalsSummary } from 'src/utils/quote/quoteTotalsSummary/soundProdTotalsSummary'

async function getQuoteTotalSummary({
	quoteDetails,
	quoteInfo,
	recapInfo,
}: {
	quoteDetails: ReduxQuote
	quoteInfo: ReduxQuoteInfo[]
	recapInfo: ReduxRecapInfo[]
}) {
	switch (quoteDetails?.quoteType) {
		case 'frenchApfp':
			return quoteTotalsSummary(
				quoteDetails,
				quoteInfo,
				recapInfo
			) as QuoteTotals
		case 'frenchPostProd':
			return quoteTotalsSummary(
				quoteDetails,
				quoteInfo,
				recapInfo
			) as QuoteTotals
		case 'aicp':
			// ! Aicp totals don't work for project totals fix totals api before changing this
			return quoteTotalsSummary(
				quoteDetails,
				quoteInfo,

				recapInfo
			) as QuoteTotals
		// return quoteTotalsAicpSummary(quoteDetails, quoteInfo, recapInfo)
		case 'photoGrid':
			return photoGridTotalsSummary(
				quoteDetails,
				quoteInfo,
				recapInfo
			) as QuoteTotals
		case 'soundProd':
			return soundProdTotalsSummary(
				quoteDetails,
				quoteInfo,
				recapInfo
			) as QuoteTotals
		default:
			return quoteTotalsSummary(
				quoteDetails,
				quoteInfo,
				recapInfo
			) as QuoteTotals
	}
}

export default getQuoteTotalSummary
